import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { EditableFormField } from "Backend";
import { useContext, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { addFormField, selectLensEditorForm, selectLensEditorLensId } from "redux/slices/lensEditor";
import FormFieldEditor from "./FormFieldEditor";
import { useSnackbar } from "notistack";
import { Download } from "@mui/icons-material";
import { FieldImport } from "routes/lens-editor/profile-builder/FieldImport";
import { LensUpdateSnackbarContext } from "contexts/LensUpdateSnackbarContext";

interface NewFormFieldDialogProps {
  open: boolean;
  close: () => void;
  sectionId: number;
}

const NewFormFieldDialog = ({ open, close, sectionId }: NewFormFieldDialogProps) => {
  const lensForm = useAppSelector(selectLensEditorForm);
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const form = useAppSelector(selectLensEditorForm);
  const lensId = useAppSelector(selectLensEditorLensId);

  const [importMode, setImportMode] = useState<boolean>(false);
  const { enqueueLensUpdateTimerSnackbar } = useContext(LensUpdateSnackbarContext);
  const save = (field: EditableFormField) => {
    dispatch(
      addFormField({
        formId: lensForm.id,
        field: {
          ...field,
          cells: [],
          sectionId,
        },
      })
    )
      .unwrap()
      .then(() => {
        enqueueSnackbar("Field Added", {
          variant: "success",
        });
        close();
        enqueueLensUpdateTimerSnackbar(lensId);
      })
      .catch((gqlError) => {
        enqueueSnackbar(`Unable to add field - ${gqlError?.message}`, {
          variant: "error",
        });
      });
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      {importMode ? (
        <FieldImport onClose={close} sourceFormId={form.id} defaultSectionId={sectionId} />
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              p: 1,
            }}>
            <DialogTitle>New Form Field</DialogTitle>
            <Button variant="outlined" startIcon={<Download />} onClick={() => setImportMode(true)}>
              Import Field
            </Button>
          </Box>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
            }}>
            <FormFieldEditor isLive={true} rank={lensForm.fields.length} onSave={save} defaultSectionId={sectionId} />
          </DialogContent>
        </>
      )}
    </Dialog>
  );
};

export default NewFormFieldDialog;
